import { render, staticRenderFns } from "./AccountConfigFeatures.vue?vue&type=template&id=5827a5ae&scoped=true"
import script from "./AccountConfigFeatures.vue?vue&type=script&lang=js"
export * from "./AccountConfigFeatures.vue?vue&type=script&lang=js"
import style0 from "./AccountConfigFeatures.vue?vue&type=style&index=0&id=5827a5ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5827a5ae",
  null
  
)

export default component.exports